<div class="login">

  <!-- Right panel: form -->
  <div class="login__panel login__panel--right">
    <form class="login-form signup-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <div class="login-form__field">
        <label class="login-form__label" for="first-name">First Name</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="text"
            id="first-name"
            formControlName="first_name"
            placeholder="John"
            autocomplete="given-name"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="last-name">Last Name</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="text"
            id="last-name"
            formControlName="last_name"
            placeholder="Doe"
            autocomplete="family-name"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="email">Email</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="email"
            id="email"
            formControlName="email"
            placeholder="name@ask-mila.com"
            autocomplete="email"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="password">Password</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="password"
            id="password"
            formControlName="password"
            placeholder="At least 6 characters"
            autocomplete="new-password"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="password-confirmation">Confirm Password</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="password"
            id="password-confirmation"
            formControlName="password_confirmation"
            placeholder="Repeat password"
            autocomplete="new-password"
          />
        </div>
        <p class="login-form__error" *ngIf="passwordMismatch">Passwords don't match.</p>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="organization-name">Organization Name <span class="login-form__label-hint">(optional)</span></label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="text"
            id="organization-name"
            formControlName="organization_name"
            placeholder="e.g. Cikisi"
            autocomplete="organization"
          />
        </div>
        <p class="login-form__hint">If your email matches a company we already work with, you'll join its existing organization instead.</p>
      </div>

      <div class="signup-form__actions">
        <button class="btn btn--primary" type="submit" [disabled]="isLoading" [attr.aria-busy]="isLoading">
          @if (isLoading) {
            <span class="spinner" aria-hidden="true"></span>
            Creating account…
          } @else {
            Create account
          }
        </button>

        <p class="auth-form__divider">OR</p>

        <button class="oauth-btn" type="button" (click)="signInWithSso('google')">
          <svg class="oauth-btn__icon" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7955 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.3441 0-4.3287-1.5831-5.0364-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z" fill="#34A853"/>
            <path d="M3.9636 10.71c-.18-.54-.2827-1.1168-.2827-1.71s.1027-1.17.2827-1.71V4.9582H.9573A8.9965 8.9965 0 000 9c0 1.4523.3477 2.8268.9573 4.0418l3.0063-2.3318z" fill="#FBBC05"/>
            <path d="M9 3.5795c1.3214 0 2.5077.4541 3.4404 1.346l2.5813-2.5814C13.4632.8918 11.4259 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582l3.0063 2.3318C4.6713 5.1626 6.6559 3.5795 9 3.5795z" fill="#EA4335"/>
          </svg>
          Continue with Google
        </button>

        <button class="oauth-btn" type="button" (click)="signInWithSso('microsoft')">
          <svg class="oauth-btn__icon" width="18" height="18" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          Continue with Microsoft
        </button>

        <button class="oauth-btn" type="button" (click)="signInWithSso('cikisi')">
          <img class="oauth-btn__icon" src="/assets/cikisi/c-logo-blue.svg" alt="" aria-hidden="true" />
          Continue with Cikisi
        </button>

        <p class="login-form__footer">
          Already have an account? <a routerLink="/login" class="link">Back to sign in</a>
        </p>
      </div>

    </form>
  </div>

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

</div>
